import { NavLink } from "react-router-dom";
import { BookOpen, LayoutDashboard, Library as LibraryIcon, LogOut, ClipboardList, Store } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { ROLE_LABELS, isStoreRole } from "@/lib/api";

export function Shell({ children }) {
  const { user, logout } = useAuth();
  const store = isStoreRole(user);
  return <div className="app-shell">
    <aside className="sidebar">
      <div className="brand-line"><span className="brand-mark small">LD</span><b>Lapak Digitals</b></div>
      <p className="nav-label">RUANG KERJA</p>
      <NavLink end data-testid="nav-dashboard-link" to="/"><LayoutDashboard size={17}/> Ringkasan</NavLink>
      {store && <>
        <NavLink data-testid="nav-products-link" to="/products"><BookOpen size={17}/> Produk</NavLink>
        <NavLink data-testid="nav-orders-link" to="/orders"><ClipboardList size={17}/> Pesanan</NavLink>
      </>}
      {user.role === "admin" && <NavLink data-testid="nav-sellers-link" to="/sellers"><Store size={17}/> Penjual</NavLink>}
      {!store && <NavLink data-testid="nav-library-link" to="/library"><LibraryIcon size={17}/> Perpustakaan</NavLink>}
      <p className="nav-label account-label">AKUN</p>
      <div className="user-chip" data-testid="current-user-info">
        <span>{user.name?.slice(0, 1) || "L"}</span>
        <div><b>{user.name}</b><small>{ROLE_LABELS[user.role]}{store && user.store_name ? ` · ${user.store_name}` : ""}</small></div>
      </div>
      <button className="logout-button" data-testid="logout-button" onClick={logout}><LogOut size={16}/> Keluar</button>
    </aside>
    <main className="content">{children}</main>
  </div>;
}
